import { AxiosInstance, AxiosResponse } from "axios";

const CARRIERS_PATH = "/resource-manager/carriers";

interface ApiEnvelope<T> {
  success: boolean;
  message?: string;
  data: T;
}

/** A carrier as the admin endpoints return it (chopper-backend CTX-785). */
export interface CarrierResponse {
  id: number;
  name: string;
  code: string | null;
  /** False hides it from new Carrier Bridge services; existing ones keep it. */
  available: boolean;
  /** Carrier Bridge services that use it, drafts included. */
  serviceCount: number;
}

/** Body of create (POST) and update (PUT); on update only what changed. */
export interface CarrierPayload {
  name?: string;
  /** Null clears the code. */
  code?: string | null;
  available?: boolean;
}

/** GET /v1/resource-manager/carriers — every carrier, hidden ones included. */
export function fetchCarriers(
  api: AxiosInstance
): Promise<AxiosResponse<ApiEnvelope<CarrierResponse[]>>> {
  return api.get(CARRIERS_PATH, { params: { includeUnavailable: true } });
}

export function createCarrier(
  api: AxiosInstance,
  payload: CarrierPayload
): Promise<AxiosResponse<ApiEnvelope<CarrierResponse>>> {
  return api.post(CARRIERS_PATH, payload);
}

export function updateCarrier(
  api: AxiosInstance,
  id: number,
  payload: CarrierPayload
): Promise<AxiosResponse<ApiEnvelope<CarrierResponse>>> {
  return api.put(`${CARRIERS_PATH}/${id}`, payload);
}

/** 409 `CARRIER_IN_USE` (with `serviceCount`) while any service uses it. */
export function deleteCarrier(
  api: AxiosInstance,
  id: number
): Promise<AxiosResponse<ApiEnvelope<unknown>>> {
  return api.delete(`${CARRIERS_PATH}/${id}`);
}
